import React, { useEffect, useState } from 'react';

import { Box, IconButton, Tooltip, useTheme } from '@mui/material';

import { IconWrapper } from 'components/Icon';
import { useAuth } from 'lib/auth';

import { useToggleStar } from '../api/toggleStar';

export const StarButton = ({
  jobAdID,
  isStarred = false,
  assignedUserID,
  onChange,
  size = 20,
  sx = {},
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  const [starred, setStarred] = useState(isStarred);

  useEffect(() => {
    setStarred(isStarred);
  }, [isStarred]);

  const { mutate, isLoading } = useToggleStar({
    onSuccess: ({ starred }) => {
      if (onChange) onChange(starred);
    },
    // Revert the optimistic update
    onError: ({ starred }) => setStarred(!starred),
  });

  if (!user || !jobAdID) return null;

  // The assigned user monitors the ad for as long as they stay assigned.
  const locked = !!assignedUserID && assignedUserID === user.user_id;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const next = !starred;
    setStarred(next);
    mutate({ jobAdID, starred: next });
  };

  const isFilled = starred || locked;
  const color = isFilled ? theme.palette.warning.main : theme.palette.grey[500];
  const label = locked
    ? 'You are monitoring this job ad as its assigned user'
    : starred
      ? 'Stop monitoring'
      : 'Monitor this job ad';

  return (
    <Tooltip title={label}>
      {/* span keeps the tooltip working while the button is disabled */}
      <Box component="span" sx={{ display: 'inline-flex', ...sx }}>
        <IconButton
          onClick={handleClick}
          disabled={isLoading || locked}
          aria-label={label}
          aria-pressed={isFilled}
          size="small"
        >
          <IconWrapper
            icon={isFilled ? 'star' : 'starOutline'}
            height={size}
            sx={{
              display: 'flex',
              svg: {
                height: size,
                width: size,
                color,
                stroke: color,
                strokeWidth: isFilled ? 0 : 1.5,
              },
            }}
          />
        </IconButton>
      </Box>
    </Tooltip>
  );
};
